import React, { useEffect, useState } from 'react';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { SingleDatePicker } from 'react-dates';
import esLocale from 'moment/locale/es';
import moment from 'moment';

const InputField = (props) => {
  const { label, placeholder, type, required, disabled, maxLength, pattern, onChange, value, options, rows, cols } = props;
  const className = `field`;
  const classNameInput = `ui input ${required ? 'required' : ''}`;
  const regexp = new RegExp(pattern);
  const [focused, setFocused] = useState(false);
  let valueVerified = value;
  const key = `input-${label?.toString().replace(/\s+/g, '-')}`;

  useEffect(() => {
    moment.locale('es', esLocale);
  }, []);

  const onFocusChange = () => {
    setFocused(!focused);
  };

  if (value && regexp && !regexp.test(value)) {
    valueVerified = value.toString().slice(0, -1);
  }

  let floatValue = '';
  if (type === 'number' && !isNaN(parseFloat(valueVerified))) {
    floatValue = parseFloat(valueVerified);;
  }

  const renderError = ({ error, required, key }) => {
    const errorDisplay = required ? (valueVerified === '' ? true : false) : false;
    error = errorDisplay ? 'El campo es requerido' : error;

    if (errorDisplay || error) {
      return (
        <div key={"error_" + key} className="error-message">
          {error}
        </div>
      );
    }
  };

  const selectOption = (item, i) => {

    if (item.value === value) {
      return <option key={`${key}_${i}`} value={item.value} selected> {item.display} </option>;
    }
    else {
      return <option key={`${key}_${i}`} value={item.value}> {item.display}</option>;
    }
  };

  const renderInputField = () => (
    <div className={className}>
      <label> {label} </label>
      <div className={classNameInput}>
        <input
          autoComplete="off"
          type={type}
          disabled={disabled}
          value={type === 'number' ? floatValue : valueVerified}
          onChange={onChange}
          placeholder={placeholder}
          maxLength={maxLength}
        />
      </div>
      {
        renderError({ ...props, key })
      }
    </div>
  );

  const renderSelectField = () => (
    <div className={className}>
      <label> {label} </label>
      <div className="ui input">
        <select type={type} onChange={onChange} disabled={disabled}>
          {
            options.map((item, i) => selectOption(item, i))
          }
        </select>
      </div>
      {/*renderError(meta)*/}
    </div>
  );

  const normalizeDates = date =>
    date ? moment(date) : null;

  const renderDatePickerField = () => (
    <div className={className}>
      <label> {label} </label>
      <div className={classNameInput}>
        <SingleDatePicker
          showClearDate={false}
          showDefaultInputIcon={false}
          displayFormat="DD-MM-YYYY"
          numberOfMonths={1}
          disabled={disabled}
          placeholder={placeholder}
          date={normalizeDates(value)}
          onDateChange={onChange}
          focused={focused}
          onFocusChange={onFocusChange}
          isOutsideRange={() => false}
        />
        {//renderError(meta)
        }
      </div>
    </div >
  );

  const renderTextAreaField = () => (
    <div className={className}>
      <label> {label} </label>
      <div className={classNameInput}>
        <textarea
          autoComplete="off"
          type={type}
          disabled={disabled}
          cols={cols}
          rows={rows}
          value={type === 'number' ? floatValue : valueVerified}
          onChange={onChange}
          placeholder={placeholder}
          maxLength={maxLength}
        />
      </div>
      {
        renderError(props)
      }
    </div>

  )




  const renderField = () => {
    switch (type) {
      case 'number':
        return renderInputField();
      case 'text':
        return renderInputField();
      case 'select':
        return renderSelectField();
      case 'datePicker':
        return renderDatePickerField();
      case 'textArea':
        return renderTextAreaField();
      default:
        return '';
    }
  }

  return (renderField());
};

export default InputField;